/**
 * Terminal-page navigator for blocked account statuses (inactive, suspended,
 * removed, deleted).
 *
 * Mirrors apiService's no-network / service-unavailable navigators: App.tsx
 * registers a client-side `history.push` so the block lands without a full
 * reload, and we fall back to `window.location.assign` when the block fires
 * before the router has mounted (whoami can resolve during InitAuth, ahead of
 * the navigator registration).
 *
 * The page reads the status off `useProfileStore().activeProfile` — the
 * session is deliberately left intact (the user stays authenticated behind
 * the wall), so there's no status to carry here.
 */
import { logWarn } from './loggerService';

export const ACCOUNT_STATUS_PATH = '/account-status';

let accountStatusNavigator: (() => void) | null = null;

export function setAccountStatusNavigator(fn: (() => void) | null) {
  accountStatusNavigator = fn;
}

export function handleBlockedAccountStatus(status: string) {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === ACCOUNT_STATUS_PATH) return;

  logWarn('Account blocked by profile status', undefined, { status });

  if (accountStatusNavigator) {
    accountStatusNavigator();
  } else {
    window.location.assign(ACCOUNT_STATUS_PATH);
  }
}
